export enum GradeYears {
  All = 0,
  Toddler = 1,
  Kindergarten1 = 4,
  Kindergarten2 = 5,
  Kindergarten3 = 6,
  ElementarySchool1 = 7,
  ElementarySchool2 = 8,
  ElementarySchool3 = 9,
  ElementarySchool4 = 10,
  ElementarySchool5 = 11,
  ElementarySchool6 = 12,
  MiddleSchool1 = 13,
  MiddleSchool2 = 14,
  MiddleSchool3 = 15,
  HighSchool1 = 16,
  HighSchool2 = 17,
  HighSchool3 = 18,
  University1 = 19,
  University2 = 20,
  University3 = 21,
  University4 = 22,
  University5 = 23,
  Master1 = 24,
  Master2 = 25,
  Doctor1 = 26,
  Doctor2 = 27,
  Doctor3 = 28,
  CollegeStudents = 50,
  Adult = 80,
}

export function getGradeYearName(value: GradeYears) {
  switch (value) {
    case GradeYears.All: return 'すべて';
    case GradeYears.Toddler: return '0～3歳';
    case GradeYears.Kindergarten1: return '年少';
    case GradeYears.Kindergarten2: return '年中';
    case GradeYears.Kindergarten3: return '年長';
    case GradeYears.ElementarySchool1: return '小学1年生';
    case GradeYears.ElementarySchool2: return '小学2年生';
    case GradeYears.ElementarySchool3: return '小学3年生';
    case GradeYears.ElementarySchool4: return '小学4年生';
    case GradeYears.ElementarySchool5: return '小学5年生';
    case GradeYears.ElementarySchool6: return '小学6年生';
    case GradeYears.MiddleSchool1: return '中学1年生';
    case GradeYears.MiddleSchool2: return '中学2年生';
    case GradeYears.MiddleSchool3: return '中学3年生';
    case GradeYears.HighSchool1: return '高校1年生';
    case GradeYears.HighSchool2: return '高校2年生';
    case GradeYears.HighSchool3: return '高校3年生';
    case GradeYears.University1: return '大学1年生';
    case GradeYears.University2: return '大学2年生';
    case GradeYears.University3: return '大学3年生';
    case GradeYears.University4: return '大学4年生';
    case GradeYears.University5: return '大学5年生';
    case GradeYears.Master1: return '修士1年生';
    case GradeYears.Master2: return '修士2年生';
    case GradeYears.Doctor1: return '博士1年生';
    case GradeYears.Doctor2: return '博士2年生';
    case GradeYears.Doctor3: return '博士3年生';
    case GradeYears.CollegeStudents: return '大学生';
    case GradeYears.Adult: return '大人';
  }
}

export function getGradeYearItems(isAll: boolean, allDisplayedText: string | null = null) {
  const items = new Array();
  for (const item in GradeYears) {
    if (!isNaN(Number(item))) {
      const num = Number(item);
      if (isAll || num !== GradeYears.All) {
        if (num === GradeYears.All && !!allDisplayedText) {
          items.push({
            id: num,
            name: allDisplayedText
          });
        } else {
          items.push({
            id: num,
            name: getGradeYearName(num)
          });
        }
      }
    }
  }
  return items;
}

export function getElementarySchoolGradeYearItems(isAll: boolean) {
  return [
    GradeYears.All,
    GradeYears.ElementarySchool1,
    GradeYears.ElementarySchool2,
    GradeYears.ElementarySchool3,
    GradeYears.ElementarySchool4,
    GradeYears.ElementarySchool5,
    GradeYears.ElementarySchool6,
  ].filter((id) => isAll || id !== GradeYears.All)
    .map((id) => ({ id, name: getGradeYearName(id) }));
}

export function getMiddleSchoolGradeYearItems(isAll: boolean) {
  return [
    GradeYears.All,
    GradeYears.MiddleSchool1,
    GradeYears.MiddleSchool2,
    GradeYears.MiddleSchool3,
  ].filter((id) => isAll || id !== GradeYears.All)
    .map((id) => ({ id, name: getGradeYearName(id) }));
}

export function getHighSchoolGradeYearItems(isAll: boolean) {
  return [
    GradeYears.All,
    GradeYears.HighSchool1,
    GradeYears.HighSchool2,
    GradeYears.HighSchool3,
  ].filter((id) => isAll || id !== GradeYears.All)
    .map((id) => ({ id, name: getGradeYearName(id) }));
}
